// extracted by mini-css-extract-plugin
module.exports = {"component":"stars-rating_component__272W2","filled":"stars-rating_filled__12Xl9","unfilled":"stars-rating_unfilled__WaSgI"};